export * from './mobx-4.3.1/lib/mobx.module.js'
import * as mobx from './mobx-4.3.1/lib/mobx.module.js'
window.mobx = mobx;